// src/pages/StoreManagementWorkflow.jsx
import React from 'react';
import ZoomableImage from '../components/ZoomableImage';
import './Workflows.css';

export default function StoreManagementWorkflow() {
  const svgPath = '/svgs/nesim-store-management-workflow.svg';

  return (
    <div className="workflow-page">
      <h1>NESIM Store Management Workflow</h1>
      <p>
        This flowchart illustrates our store operations—from receiving and inventory management to order dispatch and storage optimization.
      </p>

      <div className="svg-container">
        <ZoomableImage src={svgPath} alt="NESIM Store Management Workflow" />
      </div>

      <div className="download-container">
        <a
          href={svgPath}
          download="nesim-store-management-workflow.svg"
          className="download-button"
        >
          Download SVG
        </a>
      </div>
    </div>
  );
}
